import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
  },
  select: { whiteSpace: "normal", overflowWrap: "anywhere", height: "auto" },
  menuItem: { whiteSpace: "normal", overflowWrap: "anywhere" },
  title: {
    color: theme.palette.primary.main,
    marginBlock: "16px",
    fontWeight: "bold",
  },
}));

function CustomSelect({ title, value, handleChange, options,hideTitle, disabled = false }) {
  const classes = useStyles();
  return (
    <>
      {!hideTitle && <Typography className={classes.title}>{title}</Typography>}
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel id="demo-simple-select-outlined-label">{title}</InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          value={value}
          disabled={disabled}
          onChange={(e) => handleChange(e.target.value)}
          label={title}
          classes={{ select: classes.select }}
          MenuProps={{ PaperProps: { style: { maxWidth: 'calc(100vw - 32px)' } } }}
        >
          {options.map((item, index) => (
            <MenuItem value={item.value} key={index} className={classes.menuItem}>
              {item.text}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
}

export default CustomSelect;
